import {useTranslation} from "react-i18next";
import {useAppContext} from "../../../../context/AppContext";
import React, {useRef} from "react";
import {cenaFormat, inzerceAdminExportableFields, useInzercePdfLayout} from "../zadani/InzerceCiselnik";
import {cenaConstraint, getExportableProps} from "../_vp/PrepravaAVozidlaShared";
import {
    useCurrencySelectObj,
    useInzeratInvalDuvSelect,
    useUserBasicSelect
} from "../../../../raal_components/SelectOptions";
import {useLocalizeCiselnikValue} from "../../../../context/DataContext";
import {CiselnikTyp} from "../../../../model/Ciselnik";
import {DataGridExposed} from "../../../../raal_components/grid/DataGrid";
import {
    InvalidDuvodInzerat, Inzerat,
    InzeratFilterOznaceno,
    InzeratView,
    InzeratViewAdmin,
    InzeratViewArchiv,
    InzeratViewDetail
} from "../../../../model/Inzerat";
import {Dial} from "../../../../raal_components/dial/Dial";
import {FormField, FormInputType} from "../../../../raal_components/form/Form";
import {FormNumberRange} from "../../../../../common/component/form/FormNumberRange";
import {FormDateRange, FormDateRangeOptions} from "../../../../../common/component/form/FormDateRange";
import {Column} from "../../../../raal_components/grid/DataGrid.d";
import {TabHelperNew} from "../../../../raal_components/controller/TabHelper";
import {InzerceViewCiselnikProps} from "../prohlizeni/InzerceViewCiselnik";
import InzerceHistoryViewPart from "../prohlizeni/InzerceHistoryViewPart";
import {ComponentMode} from "../../../../routes";
import {InzerceCiselnikFormNew} from "../_inzerce/InzerceCiselnikForm";
import {InzeratViewDetailFormBasicPartNew} from "../_inzerce/InzerceCiselnikViewDetailFormBasicPart";
import {useClearZaznamOznaceni, useZaznamOznaceni, useZaznamOznaceniStyle, ZaznamOznaceniTyp} from "../Oznaceni";
import {InlinePhoneNumberDial} from "../../../../../common/component/PhoneNumberDial";
import {Grid} from "@material-ui/core";
import {parsePhoneNumberLocal} from "../../../../../common/utils/Util";


export const InzerceCiselnikArchive = (props: InzerceViewCiselnikProps) => {
    const {t} = useTranslation();
    const {user} = useAppContext();
    const oznacenoFilter = useRef(false);
    const refreshFun = useRef(() => {});
    const rangeCenaSharedOptions = {numberProps: {format: cenaFormat, constraint: cenaConstraint}};
    const dateKey = "inzerat-archive-browse-date";
    const endpoint = 'user/inzerat-archiv'
    const locFun = useLocalizeCiselnikValue(CiselnikTyp.I);
    const invalDuvSelect = useInzeratInvalDuvSelect({isClearable: true});
    const dtGrid = useRef<DataGridExposed<InzeratViewAdmin, InzeratFilterOznaceno>>();
    const {pdfLayout} = useInzercePdfLayout(user);
    const currencySelectProps = useCurrencySelectObj({isClearable:true});
    const userSelectProps = useUserBasicSelect({isClearable:true});
    const zaznamOznaceni = useZaznamOznaceniStyle(ZaznamOznaceniTyp.ARCHIV_ZADANI_INZERCE);
    const clearZaznamOznaceni = useClearZaznamOznaceni(
        useZaznamOznaceni("user", ZaznamOznaceniTyp.ARCHIV_ZADANI_INZERCE),
        () => {dtGrid.current?.table()?.refresh()}
    );

    return <>
        <Dial<InzeratViewAdmin, InzeratFilterOznaceno, InzeratViewDetail>
            mode={props.mode}
            lastBrowsedDateKey={dateKey}
            logActivity
            gridRef={dtGrid}
            firstTabName={() => t("MobileApp.Advertising.AdvertisingDetail")}
            onGridMount={()=>{
                refreshFun.current = () => dtGrid.current?.table()?.refresh();
                oznacenoFilter.current = dtGrid.current.table().getFilter().filters.oznaceno;
            }}

            onFilterChanged={(data) => {
                oznacenoFilter.current =data?.oznaceno ?? false;
            }}
            filterClazz={InzeratFilterOznaceno}
            clazzDetail={InzeratViewDetail}
            config={{
                lockSupport: {enabled: false},
                overflowHidden: true,
                requiredColumns: ['popis'],
                defaultSorting: ['popis', 'asc'],
                alternativeButtons: [clearZaznamOznaceni],
                isViewTable: true,
                exportConfig: {
                    exportable: true,
                    endpoint: endpoint,
                    fileName: "export_archiv_inzerce",
                    translationPrefix: ['Inzerce', 'User', 'Preprava', 'Archive'],
                    formats: ["pdf", "xls", "csv", "xml"],
                    exportAllFormats: ["csv"],
                    pdfLayout: (data, fields, pageBreak, index, origin) => pdfLayout(data, fields, pageBreak, index, origin),
                    exportableProps: getExportableProps(inzerceAdminExportableFields,true),
                    excludedProps: [
                        {
                            type: ["csv", "xls"],
                            fields: ["id", "sekce"]
                        }
                    ],
                    extendedProps: [
                        {
                            type: ["csv", "xls"],
                            addExtendedProps: (data) => {
                                return {
                                    provozovna: data.uzivatel?.provozovna?.kod,
                                    ...{archived: data.deletedOn}
                                }
                            }
                        }
                    ],
                    formattedProps: [
                        {
                            type: ["csv", "xls", "pdf"],
                            field: "invalDuv",
                            format: (data) => {
                                return locFun("Enumerations.InvalidDuvodInzerat", InvalidDuvodInzerat, data)
                            }
                        },
                        {
                            type: ["csv", "xls", "pdf"],
                            field: "rychlyKontakt",
                            format: (data) => {
                                return data ? parsePhoneNumberLocal(data.replace(/ /g, '')) : null;
                            }
                        }
                    ]
                },
                options: {
                    rowStyle: (data: any) => {
                        if (data.klasifikace?.barva) {
                            return {backgroundColor: data.klasifikace?.barva}
                        }
                        const oznaceniStyle = zaznamOznaceni.getStyle(data);
                        if(oznaceniStyle) return oznaceniStyle;
                    }
                },
                clazz: InzeratViewAdmin,
                hideDefaultDummyAction: false,
                tableTitle: t("Dials.AdvertisingArchivZadat").toUpperCase(),
                endpoint: endpoint,
                filtering: true,
                hideAddNewActions: true,
                defaultQueryParameters: props.filter,
                columns: [
                    {
                        title: t("Inzerce.AdText").toUpperCase(),
                        field: 'popis',
                        filterProps:() => ({type:FormInputType.Text}),
                        cellStyle: {minWidth: 200},
                        headerStyle: {minWidth: 200}
                    },
                    {
                        title: t("Default.Telefon").toUpperCase(),
                        field: 'rychlyKontakt',
                        filterProps: () => ({type: FormInputType.Text}),
                        render:(data:Inzerat)=><InlinePhoneNumberDial hideIcon phoneNumber={data.rychlyKontakt} rowData={data}/>
                    },
                    {
                        title:t('Default.Email').toUpperCase(),
                        field:"email",
                        filterProps: () => ({type: FormInputType.Text}),
                        editProps:() => ({type: FormInputType.Text}),
                        sorting: false,
                    },
                    {
                        title: t("Inzerce.Price").toUpperCase(),
                        field: 'cena',
                        render:(data:InzeratView) => data.cena,
                        filterProps:() => ({type:FormInputType.Custom, customComponent:FormNumberRange, name:"cenaRange", customComponentOptions:{...rangeCenaSharedOptions, verticalSpace: 0}}),
                        cellStyle: {textAlign:"right"}
                    },
                    {
                        title: t("Preprava.currency").toUpperCase(),
                        field: "currency",
                        render:(data:InzeratView)=> data.currency?.name ?? '',
                        filterProps:() => ({type: FormInputType.Select, selectProps: currencySelectProps}),
                    },
					{
						title: t("Default.Jednotka").toUpperCase(),
						field: 'jednotka',
						render:(data:InzeratView) => data.jednotka,
						filterProps: () => ({type: FormInputType.Text})
					},
                    {
                        title: t("User.Title").toUpperCase(),
                        field: 'uzivatel',
                        render:(row:InzeratViewArchiv)=> row.uzivatel ? `${row.uzivatel?.login ?? ''} ${row?.uzivatel.jmeno ? `(${row.uzivatel.jmeno})` : ""}` : '',
                        filterProps:() => ({type: FormInputType.Select, selectProps: userSelectProps}),
                        cellStyle: {minWidth: 180},
                        headerStyle: {minWidth: 180}
                    },
                    // #4814 - requirement to remove
                    // {
                    //     title: t("Inzerce.Dispecer").toUpperCase(),
                    //     field: 'dispecer',
                    //     render:(row:InzeratView)=> `${row.dispecer?.jmeno ?? ''}`,
                    //     filterProps:() => ({type: FormInputType.Text, name: "dispecerText"}),
                    //     cellStyle: {width: 200, maxWidth: 200},
                    //     headerStyle: {width: 200, maxWidth: 200}
                    // },
                    {
                        title: t("PVI.Modified").toUpperCase(),
                        field: 'modifiedOn',
                        render: (data: any) => data.modifiedOn?.format("L LT"),
                        filterProps:() => ({type:FormInputType.Custom, customComponent:FormDateRange, customComponentOptions:{timeFormat: false, verticalSpace: 0},  name: "modifiedOnRange"}),
                    },
                    {
                        title: t("PVI.InvalDuv").toUpperCase(),
                        field: 'invalDuv',
                        render: (data: InzeratViewAdmin) =>  {return locFun("Enumerations.InvalidDuvodInzerat", InvalidDuvodInzerat, data.invalDuv)},
                        filterProps: () => ({type: FormInputType.Select, selectProps: invalDuvSelect}),
                        cellStyle: {minWidth: 180},
                        headerStyle: {minWidth: 180}
                    },
                    {
                        title: t("Archive.Archived").toUpperCase(),
                        field: 'deletedOn',
                        defaultSort: "desc",
                        render:(data:InzeratViewAdmin) =>  data.deletedOn?.format("L LT") ?? "",
                        filterProps:() => ({type:FormInputType.Custom, customComponent:FormDateRange, customComponentOptions:{timeFormat: false, verticalSpace: 0},  name: 'deletedOnRange'}),
                    }
                ].filter(i => Boolean(i)) as Column<InzeratView>[]
            }}
            layoutDetail={()=><TabHelperNew<InzeratViewDetail> render={(data) =>
                <>
                    <InzeratViewDetailFormBasicPartNew data={data} archive/>
                </>}/>}
            crudConfig={{addEnabled:false, editEnabled:false, removeEnabled: false}}
            layoutFilter={() => <InzerceArchiveFilter {...{
                lastBrowseDateDataKey: dateKey,
                isArchiveOfOwnOffers: true
            }}/>}
            layoutForm={() => <InzerceCiselnikFormNew archiveZadani={true} />}
            isDetailReadOnly
            formDisabled={() => true}
            hideSaveButton
            hideNewButtonOnEdit
            tabs={[
                {
                    title: t("Inzerce.History"),
                    render: ()=><TabHelperNew<InzeratViewDetail> render={(data) => <InzerceHistoryViewPart inzerat={data} archive mode={ComponentMode.GridMode}/>}/>
                }
            ]}

        />
    </>
}

type InzerceArchiveFilterProps = {
    lastBrowseDateDataKey:string
    isArchiveOfOwnOffers?: boolean
}

function InzerceArchiveFilter(props: InzerceArchiveFilterProps) {
    const {t} = useTranslation();

    const currencySelectProps = useCurrencySelectObj({isClearable: true});
    const rangeCenaSharedOptions = {numberProps: {format: cenaFormat, constraint: cenaConstraint}};
    return (
        <Grid container spacing={1}>

            <Grid item xs={12} sm={6} lg={4}>
                <FormField
                    title={t("Inzerce.Description")}
                    name='popis'
                    type='text'/>
            </Grid>

            <Grid item xs={12} sm={6} lg={4}>
                <FormField
                    title={t("Default.Telefon")}
                    name='rychlyKontakt'
                    type='text'/>
            </Grid>

            <Grid item xs={12} sm={6} lg={4}>
                <FormField
                    title={t("Default.Email")}
                    name='email'
                    type='text'/>
            </Grid>

            <Grid item xs={12} sm={6} lg={4}>
                <FormField
                    title={t("Provozovna.Kod")}
                    name='provozovna'
                    type='text'/>
            </Grid>

            <Grid item xs={12} sm={6} lg={4}>
                <FormField
                    title={t("Inzerce.Dispecer")}
                    name='dispecerText'
                    type='text'/>
            </Grid>

            <Grid item xs={12} sm={6} lg={4}>
                <FormField
                    title={t("Currency.Title")}
                    name='currency'
                    type='select'
                    selectProps={currencySelectProps}
                    serverValidation={{translate: t}}/>
            </Grid>

            <Grid item xs={12} sm={6} lg={4}>
                <FormField
                    title={t("Inzerce.Price")}
                    name="cenaRange"
                    type="Custom"
                    customComponent={FormNumberRange}
                    customComponentOptions={rangeCenaSharedOptions}/>
            </Grid>

            <Grid item lg={4} sm={6} xs={12}>
                <FormField<FormDateRangeOptions>
                    title={t("PVI.Modified")}
                    name={"modifiedOnRange"}
                    type={"Custom"}
                    customComponent={FormDateRange}
                    customComponentOptions={{spacing: 1, timeFormat: false}}/>
            </Grid>

            <Grid item lg={4} sm={6} xs={12}>
                <FormField<FormDateRangeOptions>
                    title={t("Archive.Archived")}
                    name={props.isArchiveOfOwnOffers ? "deletedOnRange" : "datArchRange"}
                    type={"Custom"} customComponent={FormDateRange}
                    customComponentOptions={{spacing: 1, timeFormat: false}}/>
            </Grid>

        </Grid>
    )
}
